import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const IncomeTax = () => {
  return (
    <>
      <TopBanner content={"Income Tax"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Your Income, Your Responsibility</h2>
          <p>
            Income tax is a direct tax you pay on your income to the government.
            It applies to individuals, professionals, freelancers, and
            businesses based on how much they earn in a financial year.
          </p>
          <p>
            The tax rates are divided into slabs depending on your age and
            income level, with deductions available under various sections (like
            80C, 80D, 24(b), etc.) to reduce your taxable income.
          </p>

          <h3>Key Points:</h3>
          <ul>
            <li>Paid annually based on income slab</li>
            <li>Salaried and self-employed people both file returns</li>
            <li>Returns are filed through ITR forms</li>
            <li>PAN card is mandatory</li>
            <li>Deductions help save tax legally</li>
          </ul>

          <p>
            The better you understand your income tax, the more you
            can save smartly.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default IncomeTax;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
